import { reducer as formReducer } from 'redux-form';

export { modules } from './module/module-reducer';
// the types for formReducer seem to be wrong as they don't include the form reducer plugin
// tslint:disable-next-line:no-string-literal
const form = formReducer;
export { form };
